module.exports = __webpack_public_path__ + "img/icn_website_org.ae40b4bf.svg";